<template>
	<main id="container" class="page-container regional-festival-page">
		<div class="page-content">
			<div class="container">
				<!-- 코그페 스타일 메인 타이틀 -->
				<div class="conTitArea line main-title-area">
					<h2>지역상권(핵점포)</h2>
				</div>

				<div class="regional-container">
					<p class="mapNoticeTxt">
						※ 상권 행사 및 이벤트 정보는 추후 업데이트될 예정이며, 일부 내용은 변동될 수 있습니다.<br />
						&nbsp;&nbsp;자세한 사항은 정식 오픈 시 확인해 주시기 바랍니다.
					</p>

					<!-- 지도 및 우측 3x2 카드 리스트 영역 -->
					<div class="mapArea">
						<div class="map">
							<div class="conTitArea col">
								<h2>지역상권 찾기</h2>
								<p class="iconTxt info">
									지역을 클릭하면 해당 지역 축제 정보를 확인할 수 있습니다.
								</p>
							</div>
							<div class="mapImg">
								<svg
									width="465"
									height="705"
									viewBox="0 0 465 705"
									fill="none"
									xmlns="http://www.w3.org/2000/svg"
								>
									<g clip-path="url(#clip0_regional_map)">
										<path
											class="region"
											:class="{ curr: selectedRegionCode === 'incheon' }"
											data-region="incheon"
											data-region-name="인천"
											d="M81.4196 40.1795L84.2759 34.9385L78.6441 35.2544L68.3274 29.4545L62.9304 34.3795L66.6606 38.4298L68.5621 49.1548L63.7962 48.3609L67.842 59.329L77.6084 63.6951L81.5733 52.9701L77.8431 45.5825L81.4196 40.1795ZM39.295 0.916543L35.5162 3.24948L34.8042 12.2653L39.295 24.4565L34.8042 31.1718L50.8821 29.4302L48.8187 7.243L39.295 0.908447V0.916543ZM20.8786 7.72903L28.6465 6.80558L29.8036 3.03887L19.2927 2.01821L17.0028 7.27541L20.8786 7.72903ZM29.8036 23.29L33.8494 20.7465L30.4671 16.3965L28.7112 10.953L23.9534 17.6197L29.8036 23.29ZM56.8941 47.6724L57.0316 44.0677L50.6474 43.1766L47.1114 51.1475L56.8941 47.6643V47.6724ZM55.3243 77.2229L56.1659 83.1362L53.9407 89.0739L61.4901 83.7033L58.5529 79.653L55.3243 77.231V77.2229ZM42.216 84.2784L45.4607 83.1443L47.8477 79.6449L46.367 77.9438L42.3212 78.8592L42.216 84.2784ZM0.908691 84.8535L3.54653 85.2099L7.47902 86.5465L9.94695 83.7114L3.74882 79.6611L0.908691 84.8535ZM33.0969 51.8442L34.4967 54.9709L36.6005 54.7279L39.295 56.1698L40.6867 53.0106L37.6119 51.35L33.0969 51.8442Z"
											stroke-linecap="round"
											stroke-linejoin="round"
											transform="translate(20.021,117.327)"
											@click="selectRegion('인천', 'incheon')"
										/>
										<path
											class="region"
											:class="{ curr: selectedRegionCode === 'gyeonggi' }"
											data-region="gyeonggi"
											data-region-name="경기"
											d="M213.064 170.304L215.443 174.435L209.334 210.028L206.316 214.079L204.487 216.46L197.82 218.048V224.804L184.089 232.037L155.914 253.568L140.758 245.784L132.505 249.356L122.107 248.797L126.477 242.916L123.855 238.072L120.521 245.541L109.962 241.175L104.961 234.103L114.801 232.515L111.151 222.268L107.656 228.862C107.656 228.862 99.4753 228.7 99.2406 228.627C99.0059 228.546 99.4024 218.056 99.4024 218.056L108.845 212.021L102.574 207.647L90.1133 216.622L91.4646 210.028L88.3656 208.757L91.4646 203.994L87.8153 198.51L97.6546 199.7L102.817 202.001L104.403 198.429L106.863 196.282L108.692 191.673L101.862 191.989L92.8968 186.667L97.7356 181.029L101.7 170.304L97.9702 162.916L101.547 157.513L115.432 173.009L130.668 172.134H139.957L147.102 161.013L148.057 155.61L140.596 156.168L137.894 138.607H128.208L124.794 144.804L117.73 146.707L112.81 154.411L104.395 152.264L98.7632 152.58L88.4465 146.78L83.0494 151.705L77.3368 146.302L74.084 127.153L86.9415 127.315L87.9691 139.708L97.5737 143.759L91.4646 133.349L90.9063 115.075H89.1585V97.91L111.459 84.5604L123.442 61.5227L128.443 58.3473L132.489 62.4786L147.563 75.9091L154.708 74.3214L160.898 71.6969L161.691 79.6434L177.405 83.5398L179.946 95.0586L194.947 110.231L184.072 124.609L185.181 147.25L219.788 163.937L213.04 170.296L213.064 170.304Z"
											stroke-linecap="round"
											stroke-linejoin="round"
											@click="selectRegion('경기', 'gyeonggi')"
										/>
										<path
											class="region"
											:class="{ curr: selectedRegionCode === 'gangwon' }"
											data-region="gangwon"
											data-region-name="강원"
											d="M406.711 249.753L401.71 289.801L385.204 287.574L383.933 260.802L374.571 258.736L364.247 242.211L374.013 232.353L328.142 223.459L325.763 235.771L312.347 233.625L281.235 219.643L269.81 218.534L276.397 210.19L257.665 206.375L244.014 213.681L238.302 203.993L228.139 206.934V217.262H219.804L219.092 211.543L206.316 214.078L209.334 210.028L215.443 174.435L213.064 170.303L219.804 163.945L185.205 147.266L184.096 124.617L194.963 110.239L179.97 95.0664L177.429 83.5394L161.715 79.6512L160.922 71.7047L154.732 74.3292L147.587 75.9169L132.505 62.4863L128.459 58.3551L144.812 48.027L178.618 45.0056L219.966 46.9983L249.646 43.9768L267.901 28.7236L271.712 6.63367L281.235 0.83374L287.425 12.9925L317.664 79.6512L357.741 133.357L389.646 193.981L406.711 249.753Z"
											stroke-linecap="round"
											stroke-linejoin="round"
											@click="selectRegion('강원', 'gangwon')"
										/>
										<path
											class="region"
											:class="{ curr: selectedRegionCode === 'chungbuk' }"
											data-region="chungbuk"
											data-region-name="충북"
											d="M312.348 233.625L289.489 253.568L288.777 263.183L274.568 267.946L266.792 259.214L248.06 268.424L246.474 281.539L231.634 282.09L215.678 297.189L225.76 307.517L224.49 321.101L217.507 340.016L242.267 347.242L238.302 355.585L225.76 376.006L209.884 379.976L196.315 372.904L190.683 360.826L189.89 352.248L186.556 347.242L178.772 348.117L179.808 334.135L184.962 323.564L178.772 322.535L177.898 316.095L167.824 317.051L167.582 312.758L162.347 313.552V311.17L167.978 308.392L163.932 301.085L157.265 299.174L152.03 289.161L155.922 283.361L164.491 274.386L168.852 271.446L155.922 253.568L184.097 232.037L197.82 224.811V218.056L204.487 216.468L206.316 214.078L219.093 211.543L219.805 217.262H228.139V206.934L238.302 203.993L244.014 213.681L257.665 206.375L276.397 210.19L269.81 218.533L281.236 219.643L312.348 233.625Z"
											stroke-linecap="round"
											stroke-linejoin="round"
											@click="selectRegion('충북', 'chungbuk')"
										/>
										<path
											class="region"
											:class="{ curr: selectedRegionCode === 'chungnam' }"
											data-region="chungnam"
											data-region-name="충남"
											d="M196.315 372.904L190.918 377.991L176.239 379.028L160.048 360.834L157.823 363.694L137.271 368.303L136 366.002L137.271 360.203L133.225 358.299L109.573 364.018L104.419 370.377L88.6242 375.221L80.1281 358.615H68.2254L78.1457 348.919L72.5868 342.803L75.8396 333.43L70.6853 329.931L75.8396 324.844L70.046 318.647L75.4431 315.229L68.9375 312.766L65.6847 294.492L69.8923 285.751L67.5943 272.483L59.5028 284.001L52.8353 285.986L55.2142 275.496L50.6101 273.195L48.4659 281.774L45.6905 289.558L43.3116 275.18L32.2828 281.774L30.535 277.084L36.4095 274.224L31.5707 270.571L29.03 274.783L26.8857 269.939L30.1385 264.139L34.6617 260.486L34.8236 254.37L35.9321 249.923L43.3925 253.098L43.5543 243.564L47.2036 239.992L48.5549 250.717L45.6986 259.141L49.1941 261.604L50.6182 257.391L56.4927 254.297L58.7907 245.792L53.4746 243.013V235.067L62.7556 234.832L67.9099 255.488L70.0541 241.191L77.199 246.909L68.9456 234.516L72.2793 233.479L72.9185 228.238L87.4429 242.616L93.7947 237.448L96.0118 241.182L102.679 241.579L103.318 248.813L106.571 248.019L107.049 255.804L109.589 267.088L111.175 260.575H115.14L112.519 253.584L122.123 248.821L132.521 249.38L140.774 245.808L155.93 253.592L168.868 271.47L164.499 274.411L155.93 283.386L138.468 276.079L134.9 280.21L138.468 284.658L137.756 295.626L142.36 298.566L140.774 308.497L144.027 318.59L148.631 323.119L154.19 322.56L149.982 341.069L160.542 355.61L163.56 343.848H165.858L166.651 348.773L173.553 353.779L178.796 348.141L186.572 347.266L189.906 352.272L190.699 360.851L196.331 372.928L196.315 372.904ZM51.0066 295.707L49.9628 307.298L53.4179 310.125L51.0066 313.544L53.2318 316.031L53.4179 318.923L60.1096 318.898L57.0025 312.564L58.1272 307.331L54.4536 305.208L55.7159 302.624L53.1914 294.095L50.9985 295.707H51.0066Z"
											stroke-linecap="round"
											stroke-linejoin="round"
											@click="selectRegion('충남', 'chungnam')"
										/>
										<path
											class="region"
											:class="{ curr: selectedRegionCode === 'daejeon' }"
											data-region="daejeon"
											data-region-name="대전"
											d="M184.962 323.564L179.808 334.135L178.772 348.117L173.537 353.755L166.635 348.757L165.842 343.824H163.536L160.526 355.585L149.966 341.045L154.174 322.536L161.311 319.433L162.346 313.552L167.582 312.758L167.824 317.051L177.898 316.096L178.772 322.536L184.962 323.564Z"
											stroke-linecap="round"
											stroke-linejoin="round"
											@click="selectRegion('대전', 'daejeon')"
										/>
										<path
											class="region"
											:class="{ curr: selectedRegionCode === 'jeonbuk' }"
											data-region="jeonbuk"
											data-region-name="전북"
											d="M229.886 383.078V392.928L206.397 412.952L197.828 442.114L204.649 460.624L196.161 478.501L182.349 470.636L174.969 476.517L140.289 477.392L134.73 459.117L130.045 457.286L123.612 463.645L114.728 453.552L102.347 455.456L97.5896 469.68L78.5421 475.642L79.1813 463.807L75.2165 461.507L61.8007 465.403L60.4494 458.809L69.4958 445.703L83.7773 439.19L90.2829 440.778L86.6337 433.868L65.0454 433.074L66.4695 427.752L83.3728 414.483L90.8332 413.447L91.5452 409.55L101.546 409.631L100.276 403.353L93.0583 397.076L105.357 392.863L101.546 388.651L91.4643 392.62L83.923 388.651L84.3195 381.822L100.592 376.338L110.989 370.376H104.403L109.557 364.018L133.209 358.299L137.254 360.202L135.984 366.002L137.254 368.303L157.807 363.694L160.032 360.834L176.223 379.028L190.901 377.991L196.298 372.904L209.868 379.975L225.743 376.006L229.87 383.078H229.886ZM45.0917 430.547L41.7337 434.184L41.3857 437.359L47.2278 431.754L45.0836 430.547H45.0917Z"
											stroke-linecap="round"
											stroke-linejoin="round"
											@click="selectRegion('전북', 'jeonbuk')"
										/>
										<path
											class="region"
											:class="{ curr: selectedRegionCode === 'jeonnam_gwangju' }"
											data-region="jeonnam_gwangju"
											data-region-name="전남·광주"
											d="M86.302 629.13L88.2036 629.535L87.4187 632.087L88.2036 634.379L86.9251 638.478L84.9831 636.939L85.1935 632.038L84.9427 629.13H86.2939H86.302ZM110.253 627.348L109.088 631.204L111.548 633.747L116.022 633.658L117.309 629.527L113.716 626.335L110.245 627.34L110.253 627.348ZM157.758 649.924L159.102 652.638L162.84 652.953L160.162 650.029L159.522 646.902L157.758 649.932V649.924ZM216.228 557.125L214.545 556.833L213.186 557.084L212.692 558.275L214.27 560.924L213.008 564.278L210.96 567.153L213.396 573.593L217.879 574.241L218.744 567.737L216.098 561.159L216.228 557.117V557.125ZM87.5562 610.799L91.2622 611.374V613.124L98.7873 614.298L94.693 604.667L91.9095 600.608L86.5691 601.613L85.4201 605.703L87.5562 610.791V610.799ZM98.1723 601.208L101.093 596.526L105.981 595.448L109.08 599.944L105.649 600.6L100.681 604.764L99.5722 605.622L99.7987 602.65L98.1642 601.208H98.1723ZM100.948 608.352L107.34 606.627L113.716 607.486L112.575 611.066L108.651 612.297L105.956 610.718L102.153 610.256L100.956 608.344L100.948 608.352ZM129.106 602.933L130.846 605.404L135.369 605.622L136.631 608.19L133.451 610.143L129.818 612.257L129.244 608.279L125.174 606.505L129.106 602.941V602.933ZM142.174 590.159L148.308 588.806L152.402 589.705L152.839 593.091L149.117 595.999L143.744 597.603L139.229 594.023L139.552 592.022L138.484 591.301L142.182 590.167L142.174 590.159ZM181.272 591.779L183.87 590.564L186.403 593.658V595.975L181.491 597.797L177.72 593.213L177.486 590.483L181.272 591.787V591.779ZM207.036 580.535L210.386 579.426L214.351 581.297L216.746 585.833L216.705 587.729L212.441 588.061L208.913 584.707L207.044 580.535H207.036ZM192.584 533.877L192.026 526.246L195.441 526.011L201 531.098L207.505 519.498L210.677 522.601L217.498 522.998L210.281 510.126L201.072 498.048L199.009 487.874L196.153 478.502L182.341 470.636L174.961 476.517L140.281 477.392L134.722 459.118L130.037 457.287L123.604 463.646L114.72 453.552L102.339 455.456L97.5816 469.681L78.5341 475.642L79.1734 463.808L75.2085 461.507L61.7927 465.403L57.5123 467.785L51.9534 484.229L60.1259 498.453L61.2344 503.378L61.1535 512.678L51.9453 499.012L42.106 498.615L43.8538 508.15L47.2684 505.768L53.774 511.803L46.9448 522.131L51.9453 526.027L57.5771 519.191L60.1178 519.749L57.0997 526.108L59.6404 531.827L55.0363 543.346L66.4616 543.427L71.624 545.728L73.6064 534.444L78.0487 540.479L85.6709 543.897L76.7783 544.772L72.0933 551.924L55.7484 550.491L56.6223 554.857L69.9571 556.21L77.6522 565.906L69.6415 567.81L60.9108 559.863H57.0997L56.5413 565.663L63.9208 572.176L55.5865 572.257L49.9548 561.451L50.9824 555.335L46.2974 551.366L42.8019 563.759L55.0282 579.328L68.9133 577.344L71.6159 582.107L63.8399 586.878L69.949 596.493L66.6153 606.424L71.0576 607.461L69.6335 615.562L80.7431 612.386L84.3924 599.993L92.7267 593.399L97.7273 587.996L98.4394 577.19L101.854 574.095L103.998 579.102L103.367 590.539L113.522 594.671L117.252 589.746L125.263 580.843L127.965 570.434L142.805 559.944L149.157 559.312L154.158 549.543L157.572 554.549L164.402 554.152L165.356 559.32L162.816 563.767L156.707 559.871L153.373 564.877L156.707 572.581L149.958 575.521V568.611L139.876 578.778L142.732 582.593L151.382 579.968L162.573 594.193L170.114 590.223L175.196 582.123L167.654 580.454L165.033 575.61L170.511 572.273L177.413 576.088L184.477 574.104L180.269 565.922L170.114 551.22L166.7 550.507L171.457 546.141L168.52 542.406L180.981 539.385L184.08 533.107L187.333 541.686L191.937 553.601L187.414 559.879L191.063 565.995L199.155 567.899L198.524 558.996L207.254 556.218L213.048 538.656L202.1 542.309L192.576 533.885L192.584 533.877ZM129.252 505.752L103.853 511.39L98.2209 504.634H91.076L92.4273 493.99L103.853 484.772H108.853L119.089 482.228L123.928 484.772L126.549 492.953L132.658 494.703L129.244 505.744L129.252 505.752ZM18.6001 507.623L19.9109 502.317L23.7625 500.535L26.724 497.149L29.904 496.833L27.5008 500.657L26.8777 504.82L23.7625 510.029L18.6001 507.631V507.623ZM27.8325 510.029L30.786 509.373L32.2101 512.281L28.9168 512.378L27.8325 510.029ZM37.3725 502.965L39.6462 507.558L42.1384 512.289L39.6543 513.237L37.0893 509.405L34.5 508.522L31.7812 503.419L37.3725 502.957V502.965ZM46.4593 529.13L51.0067 531.106L48.288 535.043L52.4794 537.222L51.7511 540.94L45.6906 537.271L37.688 538.267L43.4088 535.051L45.0837 533.002L46.4512 529.122L46.4593 529.13ZM37.0893 525.331L40.9813 526.027L39.0312 528.53L37.688 528.101L37.0812 525.339L37.0893 525.331ZM20.0161 526.975L22.4112 530.353L20.6068 535.035L15.5334 535.861L9.98259 536.631L15.234 529.608L17.0465 529.956L20.0242 526.975H20.0161ZM24.8144 537.425L24.9115 534.954L28.229 535.108V538.057L25.5345 541.524L22.4112 543.719L19.296 538.915L24.8144 537.425ZM23.7625 546.149L30.0739 544.213L30.4623 547.153L24.9843 547.777L23.7625 546.149ZM20.3964 550.199L30.4542 552.087L31.1743 558.227L26.5055 555.456L23.7544 556.234L20.3964 550.199ZM12.0945 546.214L12.8956 549.567L6.80262 551.163L4.65027 554.816L0.0380859 554.209V549.235L4.10813 547.372L12.0945 546.214ZM9.80458 555.116L12.8956 558.891L8.62321 564.861L3.11287 561.961L3.21806 559.361L7.05345 557.352L9.80458 555.116ZM18.4221 575.934L14.6514 576.793L13.8908 572.135L14.6514 567.842L18.4221 575.934ZM21.4888 570.58L23.6249 573.294L22.9776 577.927L18.3735 581.58L16.4639 580.414L18.948 578.073L21.6668 575.926L18.948 570.013L21.4969 570.58H21.4888ZM39.6381 575.959L43.5868 576.793L47.5921 580.479L51.0067 580.057L54.4537 586.198L51.7269 598.283L47.05 596.574L46.8153 599.539L34.8803 605.72L28.2533 605.258L29.3861 602.577L26.8373 600.203L24.9196 601.208L23.8596 599.021L27.8245 591.366L31.1663 590.847L34.3705 586.068L42.5834 583.403L42.8585 580.527L39.63 575.975L39.6381 575.959ZM15.5658 612.297L21.3188 612.565V615.141L18.859 616.315L14.7971 615.108L15.5577 612.289L15.5658 612.297ZM73.3717 631.188L78.2348 631.949L81.1073 633.747L78.2105 633.707L75.4756 636.266L70.7177 637.563L69.6092 635.335L70.0138 632.192L73.3717 631.196V631.188ZM76.8673 623.589L81.261 624.991L81.6899 627.656L79.3999 629.527L75.8478 628.522L76.8592 623.581L76.8673 623.589Z"
											stroke-linecap="round"
											stroke-linejoin="round"
											@click="selectRegion('전남·광주', 'jeonnam_gwangju')"
										/>
										<path
											class="region"
											:class="{ curr: selectedRegionCode === 'jeonnam_gwangju' }"
											data-region="jeonnam_gwangju"
											data-region-name="전남·광주"
											d="M132.667 494.702L129.252 505.751L103.853 511.389L98.221 504.633H91.0762L92.4275 493.989L103.853 484.771H108.853L119.097 482.228L123.936 484.771L126.558 492.961L132.667 494.702Z"
											stroke-linecap="round"
											stroke-linejoin="round"
											@click="selectRegion('전남·광주', 'jeonnam_gwangju')"
										/>
										<path
											class="region"
											:class="{ curr: selectedRegionCode === 'gyeongbuk' }"
											data-region="gyeongbuk"
											data-region-name="경북"
											d="M420.523 374.654L406.71 426.691L396.871 424.706L382.743 426.14L379.968 419.862H364.173L361.155 426.618L353.848 431.389L342.026 429.955L327.267 439.968L304.967 436.711L302.507 428.927L304.012 418.834L312.104 413.593L313.771 417.327H319.807L320.681 407.874L324.969 399.133L326.555 390.312L324.969 383.078L316.077 377.043L301.237 380.543L298.777 392.936L293.858 391.349L286.154 401.045L295.363 406.764L290.281 408.352L287.821 413.593L292.264 421.693L283.452 423.84L287.498 430.514V436.152L275.514 431.786L264.485 430.514L262.818 416.687L252.34 405.565L237.654 402.066L229.878 392.928V383.078L225.751 376.006L238.293 355.585L242.258 347.242L217.498 340.008L224.481 321.101L225.751 307.517L215.669 297.189L231.617 282.09L246.457 281.531L248.043 268.424L266.775 259.206L274.551 267.946L288.76 263.183L289.472 253.568L312.331 233.625L325.746 235.771L328.125 223.458L373.996 232.361L364.238 242.211L374.554 258.736L383.916 260.802L385.187 287.574L401.694 289.801V319.433L396.855 346.764L401.143 361.863L397.729 371.478L402.171 376.719L418.678 366.95L420.506 374.654H420.523ZM422.06 219.846L433.655 221.514L437.458 211.527L434.845 203.993L419.843 208.934L422.052 219.846H422.06Z"
											stroke-linecap="round"
											stroke-linejoin="round"
											@click="selectRegion('경북', 'gyeongbuk')"
										/>
										<path
											class="region"
											:class="{ curr: selectedRegionCode === 'gyeongbuk' }"
											data-region="gyeongbuk"
											data-region-name="경북"
											d="M440.427 222.885L438.554 222.051L441.774 218.826L445.483 223.162L443.046 224.724L440.427 222.885Z"
											stroke-linecap="round"
											stroke-linejoin="round"
											@click="selectRegion('경북', 'gyeongbuk')"
										/>
										<path
											class="region"
											:class="{ curr: selectedRegionCode === 'gyeongnam' }"
											data-region="gyeongnam"
											data-region-name="경남"
											d="M377.918 463.517L374.585 467.487L370.458 468.046L360.772 476.705L352.438 485.445L339.742 492.282L331.246 496.891L336.004 503.882L330.688 505.316L329.183 502.618L319.74 503.25V497.288L315.371 498.795L310.847 494.899L308.622 486.239L305.766 491.877L312.587 506.895L308.695 508.88L304.407 503.955L294.883 501.727L294.09 505.3L285.197 509.674L283.692 515.79L294.883 509.755L294.09 517.782L288.612 519.451L289.567 530.573L293.062 530.808L291.954 534.939L285.764 538.836L287.746 534.939L280.998 534.145L277.826 531.999L280.286 528.345L277.195 525.089L272.591 529.698L269.734 527.001L264.968 526.839L263.544 532.007L254.579 531.132L253.543 527.876L245.921 524.06L247.903 505.308L240.443 511.108L239.407 517.782L235.038 518.738L232.497 514.769L229.244 522.716H217.738L210.52 509.844L201.312 497.766L199.249 487.592L196.393 478.22L204.881 460.342L198.059 441.832L206.628 412.671L230.118 392.647L237.894 401.784L252.58 405.283L263.059 416.405L264.726 430.233L275.754 431.504L287.738 435.871L302.74 428.637L305.2 436.421L327.5 439.678L342.259 429.666L354.081 431.099L354.793 435.393L350.901 439.686L373.444 455.182L377.886 463.526L377.918 463.517ZM223.645 531.707L220.546 534.988L225.32 555.036L229.333 555.952L231.914 549.795L233.816 549.65L237.878 557.985L241.115 557.215L246.431 558.374L246.714 555.036L248.178 543.242L243.202 542.084L236.413 542.635L231.308 539.961L229.827 535.547L232.084 531.788V527.033L227.577 525.931L223.637 531.723L223.645 531.707ZM240.055 529.026L235.831 534.518L237.15 538.43L242.968 538.576L249.336 539.637L245.338 532.064L242.571 533.497L241.98 528.394L240.063 529.034L240.055 529.026ZM266.012 544.692L267.914 543.283L268.998 541.444L265.81 539.208L263.836 541.12L266.012 544.7V544.692ZM318.276 513.611L317.652 519.435L311.009 523.234L310.435 530.824L305.337 529.317L297.157 534.988L300.83 542.918L308.808 539.654L305.701 548.856L308.606 550.079L305.701 557.078L318.85 554.559L316.876 550.395L318.073 543.987L325.21 546.555L323.341 540.269L324.652 533.497L322.71 532.622L323.397 525.138L322.03 512.031L318.284 513.619L318.276 513.611ZM331.44 509.309L334.103 517.823L335.939 513.716L335.996 509.309H331.44Z"
											stroke-linecap="round"
											stroke-linejoin="round"
											@click="selectRegion('경남', 'gyeongnam')"
										/>
										<path
											class="region"
											:class="{ curr: selectedRegionCode === 'daegu' }"
											data-region="daegu"
											data-region-name="대구"
											d="M326.547 390.304L324.961 399.126L320.681 407.866L319.807 417.319H313.771L312.104 413.585L304.012 418.826L302.499 428.919L287.506 436.153V430.507L283.46 423.832L292.264 421.694L287.821 413.585L290.281 408.344L295.363 406.757L286.154 401.029L293.858 391.341L298.777 392.929L301.237 380.535L316.077 377.036L324.961 383.079L326.547 390.304Z"
											stroke-linecap="round"
											stroke-linejoin="round"
											@click="selectRegion('대구', 'daegu')"
										/>
										<path
											class="region"
											:class="{ curr: selectedRegionCode === 'busan' }"
											data-region="busan"
											data-region-name="부산"
											d="M389.646 471.268L382.743 482.228L376.157 493.99L368.616 496.452L366.868 500.745H360.993L354.965 509.64L351.154 511.389L349.406 500.745L335.756 504.164L330.998 497.165L339.486 492.564L352.182 485.727L360.516 476.987L370.202 468.327L374.328 467.768L377.662 463.799L384.41 465.387L389.646 471.268Z"
											stroke-linecap="round"
											stroke-linejoin="round"
											@click="selectRegion('부산', 'busan')"
										/>
										<path
											class="region"
											:class="{ curr: selectedRegionCode === 'ulsan' }"
											data-region="ulsan"
											data-region-name="울산"
											d="M406.711 426.691L405.198 444.893L396.871 452.596L394.889 463.799L389.646 471.268L384.41 465.387L377.662 463.799L373.22 455.456L350.677 439.96L354.569 435.675L353.849 431.381L361.155 426.618L364.173 419.863H379.96L382.744 426.14L396.871 424.707L406.711 426.691Z"
											stroke-linecap="round"
											stroke-linejoin="round"
											@click="selectRegion('울산', 'ulsan')"
										/>
										<path
											class="region"
											:class="{ curr: selectedRegionCode === 'jeju' }"
											data-region="jeju"
											data-region-name="제주"
											d="M157.829 672.047L152.901 682.61L144.178 690.16L116.4 699.937L89.973 700.804L83.7749 704.781L75.2868 699.775L69.5742 692.784L72.827 683.728L86.4775 669.982L111.634 662.27L128.545 657.661L144.016 656.47L155.126 662.991L157.829 672.047Z"
											stroke-linecap="round"
											stroke-linejoin="round"
											@click="selectRegion('제주', 'jeju')"
										/>
										<path
											class="region"
											:class="{ curr: selectedRegionCode === 'sejong' }"
											data-region="sejong"
											data-region-name="세종"
											d="M167.979 308.392L162.347 311.171V313.552L161.311 319.433L154.175 322.536L148.616 323.086L144.012 318.558L140.759 308.473L142.345 298.542L137.741 295.602L138.461 284.634L134.884 280.186L138.461 276.055L155.922 283.362L152.03 289.162L157.265 299.174L163.933 301.086L167.979 308.392Z"
											stroke-linecap="round"
											stroke-linejoin="round"
											@click="selectRegion('세종', 'sejong')"
										/>
										<path
											class="region"
											:class="{ curr: selectedRegionCode === 'seoul' }"
											data-region="seoul"
											data-region-name="서울"
											d="M148.065 155.602L147.11 161.005L139.965 172.135H130.684L115.44 173.01L101.555 157.513L104.411 152.272L112.826 154.411L117.746 146.707L124.81 144.804L128.216 138.607H137.902L140.604 156.161L148.065 155.602Z"
											stroke-linecap="round"
											stroke-linejoin="round"
											@click="selectRegion('서울', 'seoul')"
										/>
									</g>
									<defs>
										<clipPath id="clip0_regional_map">
											<rect width="465" height="705" fill="white" />
										</clipPath>
									</defs>
								</svg>

								<div class="regionBtnList">
									<button
										v-for="reg in regionButtons"
										:key="reg.code"
										type="button"
										class="regionBtn"
										:class="{ curr: selectedRegionCode === reg.code }"
										:style="{ left: reg.left, top: reg.top }"
										@click="selectRegion(reg.name, reg.code)"
									>
										{{ reg.label }} <span class="mapNum">({{ getRegionCardCount(reg.name) }})</span>
									</button>
								</div>
							</div>
						</div>

						<div class="mapImgList">
							<div class="conTitArea dLeft">
								<h2><span class="cBlue" style="font-size: 22px;">{{ selectedRegionDisplayName }}</span> 지역 상권</h2>
								<span>총 <span>{{ currentRegionCards.length }}</span>개</span>
							</div>

							<div>
								<div v-if="pagedCards.length > 0" class="imgTxtList col3">
									<a
										v-for="(card, idx) in pagedCards"
										:key="card.arEventId || idx"
										class="item regional-card-item"
										:href="ensureExternalUrl(card.rltdUrl) || 'javascript:void(0);'"
										:target="ensureExternalUrl(card.rltdUrl) ? '_blank' : null"
										:rel="ensureExternalUrl(card.rltdUrl) ? 'noopener noreferrer' : null"
									>
										<p class="thumeImg">
											<img
												:src="card.imgFileUrl || defaultImg"
												:alt="card.trdarNm || card.arEventNm"
												@error="onImgError"
											/>
										</p>
										<div>
											<strong :title="card.arEventNm || card.trdarNm">{{ card.arEventNm || card.trdarNm }}</strong>
											<p class="eventDate">{{ card.displayDate }}</p>
											<p v-if="card.plcInfo" class="eventPlace" :title="card.plcInfo">{{ card.plcInfo }}</p>
										</div>
									</a>
								</div>
								<div v-else class="noDataArea">
									<p class="noDataTxt">해당 지역에 등록된 축제가 없습니다.</p>
								</div>

								<!-- 상단 카드 페이징 -->
								<div v-if="totalCardPages > 1" class="pagination v2 card-pagination">
									<div>
										<a
											href="javascript:void(0);"
											class="btnPrev"
											:class="{ disabled: cardPage <= 1 }"
											@click.prevent="cardPage > 1 && (cardPage--)"
										>이전</a>
										<template v-for="p in totalCardPages">
											<strong v-if="p === cardPage" :key="'cp-curr-' + p"><span class="hide"></span>{{ p }}</strong>
											<a v-else :key="'cp-' + p" href="javascript:void(0);" @click.prevent="cardPage = p">{{ p }}</a>
										</template>
										<a
											href="javascript:void(0);"
											class="btnNext"
											:class="{ disabled: cardPage >= totalCardPages }"
											@click.prevent="cardPage < totalCardPages && (cardPage++)"
										>다음</a>
									</div>
								</div>
							</div>
						</div>
					</div>

					<!-- 배너 영역 (고향사랑기부제 답례품몰 / 지자체몰) -->
					<div class="banner-wrap" v-if="currentGiftMallUrl || currentLocalMallUrl">
						<!-- 지자체몰이 없을 때: 메인 단독 배너 -->
						<a
							v-if="!currentLocalMallUrl && currentGiftMallUrl"
							:href="ensureExternalUrl(currentGiftMallUrl)"
							target="_blank"
							rel="noopener noreferrer"
							class="banner banner-main"
						>
							<div class="banner-content">
								<h3>고향사랑기부제 <strong class="targetRegionName">{{ targetRegionLabel }}</strong> <br><span class="targetRegionName">{{ targetRegionLabel }}</span>의 우수한 답례품을 만나보세요!</h3>
								<span class="banner-link">답례품몰 바로가기</span>
							</div>
							<div class="banner-img">
								<img src="/images/banner-gift-img.png" alt="답례품몰" />
							</div>
						</a>

						<!-- 지자체몰이 있을 때: 2열 분할 배너 -->
						<div v-else-if="currentLocalMallUrl" class="banner-row">
							<a
								:href="ensureExternalUrl(currentGiftMallUrl) || 'javascript:void(0);'"
								:target="ensureExternalUrl(currentGiftMallUrl) ? '_blank' : null"
								:rel="ensureExternalUrl(currentGiftMallUrl) ? 'noopener noreferrer' : null"
								class="banner banner-sub banner-2"
							>
								<div class="banner-img">
									<img src="/images/banner-gift-img.png" alt="답례품몰" />
								</div>
								<div class="banner-content">
									<h3>고향사랑기부제 <strong class="targetRegionName">{{ targetRegionLabel }}</strong><br /><span class="targetRegionName">{{ targetRegionLabel }}</span>의 우수한 답례품을 만나보세요!</h3>
									<span class="banner-link">답례품몰 바로가기</span>
								</div>
							</a>

							<a
								:href="ensureExternalUrl(currentLocalMallUrl)"
								target="_blank"
								rel="noopener noreferrer"
								class="banner banner-sub banner-3"
							>
								<div class="banner-img">
									<img src="/images/banner-shopping-img.png" alt="지자체몰" />
								</div>
								<div class="banner-content">
									<h3><strong class="targetRegionName">{{ targetRegionLabel }}</strong><br />농·특산물과 지역상품을 만나보세요!</h3>
									<span class="banner-link">지자체몰 바로가기</span>
								</div>
							</a>
						</div>
					</div>

					<!-- 검색 영역 -->
					<div class="srchArea">
						<div>
							<select v-model="searchRegionSelect" @change="onSearchFilter">
								<option value="">전체 지역</option>
								<option
									v-for="code in areaSelectOptions"
									:key="code.dcdVal"
									:value="code.dcdVal"
								>
									{{ code.dcdVal }}
								</option>
							</select>
							<div>
								<input
									type="text"
									v-model="searchKeyword"
									placeholder="상권명을 입력하세요."
									@keydown.enter.prevent="onSearchFilter"
								/>
								<button type="button" @click="onSearchFilter" title="검색">
									<span class="sr-only">검색하기</span>
								</button>
							</div>
						</div>
					</div>

					<!-- 하단 상권 목록 테이블 -->
					<div class="table-section">
						<div class="conTitArea line">
							<h2>상권 목록</h2>
						</div>
						<div class="list tableList">
							<table>
								<caption>
									번호, 지역명, 상권명, 상권주소, 대표 핵점포, 유망 핵점포, 행사기간, 프로모션 내용 항목으로 구성된 지역상권(핵점포) 목록 표
								</caption>
								<colgroup>
									<col style="width: 5%" />
									<col style="width: 8%" />
									<col style="width: 14%" />
									<col style="width: 18%" />
									<col style="width: 11%" />
									<col style="width: 11%" />
									<col style="width: 13%" />
									<col style="width: auto" />
								</colgroup>
								<thead>
									<tr>
										<th scope="col" class="mHide">번호</th>
										<th scope="col">지역명</th>
										<th scope="col">상권명</th>
										<th scope="col">상권주소</th>
										<th scope="col">대표 핵점포</th>
										<th scope="col">유망 핵점포</th>
										<th scope="col">행사기간</th>
										<th scope="col">프로모션 내용</th>
									</tr>
								</thead>
								<tbody>
									<template v-if="pagedTableRows.length > 0">
										<tr
											v-for="(row, idx) in pagedTableRows"
											:key="row.arEventId || idx"
											class="event-table-row"
										>
											<td class="mHide row-num">{{ (tablePage - 1) * tablePageSize + idx + 1 }}</td>
											<td data-th="지역명">{{ row.displayRegionNm || row.arDcd || '-' }}</td>
											<td data-th="상권명">
												<a
													v-if="ensureExternalUrl(row.rltdUrl)"
													:href="ensureExternalUrl(row.rltdUrl)"
													target="_blank"
													rel="noopener noreferrer"
												>
													{{ row.trdarNm || row.arEventNm }}
												</a>
												<span v-else>{{ row.trdarNm || row.arEventNm }}</span>
											</td>
											<td data-th="상권주소">{{ row.plcInfo || '-' }}</td>
											<td data-th="대표 핵점포">{{ row.coreStoreNm || '-' }}</td>
											<td data-th="유망 핵점포">{{ row.prmsStoreNm || '-' }}</td>
											<td data-th="행사기간">{{ row.displayDur || '-' }}</td>
											<td data-th="프로모션 내용" class="txtL full">
												{{ row.arEventProgram || row.eventIntro || '-' }}
											</td>
										</tr>
									</template>
									<tr v-else>
										<td colspan="8" style="text-align:center; padding: 40px 0;">
											등록된 지역상권(핵점포) 정보가 없습니다.
										</td>
									</tr>
								</tbody>
							</table>
						</div>

						<!-- 하단 테이블 페이징 -->
						<div v-if="totalTablePages > 1" class="pagination v2 table-pagination">
							<div>
								<a
									href="javascript:void(0);"
									class="btnPrev"
									:class="{ disabled: tablePage <= 1 }"
									@click.prevent="tablePage > 1 && (tablePage--)"
								>이전</a>
								<template v-for="p in totalTablePages">
									<strong v-if="p === tablePage" :key="'tp-curr-' + p"><span class="hide"></span>{{ p }}</strong>
									<a v-else :key="'tp-' + p" href="javascript:void(0);" @click.prevent="tablePage = p">{{ p }}</a>
								</template>
								<a
									href="javascript:void(0);"
									class="btnNext"
									:class="{ disabled: tablePage >= totalTablePages }"
									@click.prevent="tablePage < totalTablePages && (tablePage++)"
								>다음</a>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</main>
</template>

<script>
import { mapGetters } from 'vuex';
import { ACT_GET_COMMON_CODE_LIST, ACT_GET_AR_EVENT_LIST } from '@/store/_act_consts';
import { MUT_SET_COMMON_CODE_ITEMS } from '@/store/_mut_consts';
import { lengthCheck, getItems, getCheckItems } from '@/assets/js/utils';

export default {
	name: 'Festival',
	data() {
		return {
			defaultImg: '/images/img-logo01.png',
			allEventList: [],
			arDcdOptions: [],

			selectedRegionName: '강원',
			selectedRegionCode: 'gangwon',

			cardPage: 1,
			cardPageSize: 6,

			searchRegionSelect: '',
			searchKeyword: '',

			tablePage: 1,
			tablePageSize: 10,

			regionButtons: [
				{ code: 'seoul', name: '서울', label: '서울', left: '32%', top: '15%' },
				{ code: 'incheon', name: '인천', label: '인천', left: '15%', top: '14%' },
				{ code: 'gyeonggi', name: '경기', label: '경기', left: '39%', top: '27%' },
				{ code: 'gangwon', name: '강원', label: '강원', left: '59%', top: '18%' },
				{ code: 'sejong', name: '세종', label: '세종', left: '33%', top: '41%' },
				{ code: 'chungbuk', name: '충북', label: '충북', left: '50%', top: '35%' },
				{ code: 'chungnam', name: '충남', label: '충남', left: '19%', top: '40%' },
				{ code: 'daejeon', name: '대전', label: '대전', left: '45%', top: '46%' },
				{ code: 'jeonbuk', name: '전북', label: '전북', left: '32%', top: '57%' },
				{ code: 'jeonnam_gwangju', name: '전남·광주', label: '전남광주', left: '25%', top: '73%' },
				{ code: 'gyeongbuk', name: '경북', label: '경북', left: '70%', top: '42%' },
				{ code: 'gyeongnam', name: '경남', label: '경남', left: '61%', top: '66%' },
				{ code: 'daegu', name: '대구', label: '대구', left: '66%', top: '55%' },
				{ code: 'busan', name: '부산', label: '부산', left: '81%', top: '70%' },
				{ code: 'ulsan', name: '울산', label: '울산', left: '88%', top: '57%' },
				{ code: 'jeju', name: '제주', label: '제주', left: '27%', top: '94%' },
			],
		};
	},
	computed: {
		...mapGetters('common', ['commonCode', 'campn']),

		campnId() {
			return this.campn.campnId;
		},

		selectedRegionDisplayName() {
			return this.selectedRegionName === '전남광주' ? '전남광주' : this.selectedRegionName;
		},

		targetRegionLabel() {
			const name = this.selectedRegionName;
			if (this.normalizeRegion(name) === '전남광주') {
				return '전남광주';
			}
			if (name.endsWith('도') || name.endsWith('시')) {
				return name;
			}
			if (['서울', '부산', '대구', '인천', '대전', '울산', '세종'].includes(name)) {
				return name + '시';
			}
			return name + '도';
		},

		areaSelectOptions() {
			const options = [
				{ dcdVal: '서울' },
				{ dcdVal: '인천' },
				{ dcdVal: '경기' },
				{ dcdVal: '강원' },
				{ dcdVal: '세종' },
				{ dcdVal: '충북' },
				{ dcdVal: '충남' },
				{ dcdVal: '대전' },
				{ dcdVal: '전북' },
				{ dcdVal: '전남·광주' },
				{ dcdVal: '경북' },
				{ dcdVal: '경남' },
				{ dcdVal: '대구' },
				{ dcdVal: '부산' },
				{ dcdVal: '울산' },
				{ dcdVal: '제주' },
			];
			return options;
		},

		// 선택된 지역의 카드 목록
		currentRegionCards() {
			const normSel = this.normalizeRegion(this.selectedRegionName);
			return this.allEventList.filter((item) => {
				const normItem = this.normalizeRegion(item.displayRegionNm);
				if (normSel === '전남광주') {
					return normItem === '전남광주';
				}
				return normItem.includes(normSel) || normSel.includes(normItem);
			});
		},

		// 현재 선택 지역의 답례품몰 URL
		currentGiftMallUrl() {
			const found = this.currentRegionCards.find((x) => !!x.giftMallUrl);
			return found ? found.giftMallUrl : '';
		},

		// 현재 선택 지역의 지자체몰 URL
		currentLocalMallUrl() {
			const found = this.currentRegionCards.find((x) => !!x.localMallUrl);
			return found ? found.localMallUrl : '';
		},

		totalCardPages() {
			return Math.ceil(this.currentRegionCards.length / this.cardPageSize) || 1;
		},

		pagedCards() {
			const start = (this.cardPage - 1) * this.cardPageSize;
			return this.currentRegionCards.slice(start, start + this.cardPageSize);
		},

		// 하단 테이블 필터링된 목록
		filteredTableRows() {
			const selRegion = this.searchRegionSelect.trim();
			const normSel = this.normalizeRegion(selRegion);
			const kw = this.searchKeyword.trim().toLowerCase();

			return this.allEventList.filter((item) => {
				const rName = item.displayRegionNm || '';
				const normItem = this.normalizeRegion(rName);
				const trdar = (item.trdarNm || item.arEventNm || '').toLowerCase();

				let regionMatch = false;
				if (!selRegion) {
					regionMatch = true;
				} else if (normSel === '전남광주') {
					regionMatch = normItem === '전남광주';
				} else {
					regionMatch = normItem.includes(normSel) || normSel.includes(normItem);
				}

				const kwMatch = !kw || trdar.includes(kw);
				return regionMatch && kwMatch;
			});
		},

		totalTablePages() {
			return Math.ceil(this.filteredTableRows.length / this.tablePageSize) || 1;
		},

		pagedTableRows() {
			const start = (this.tablePage - 1) * this.tablePageSize;
			return this.filteredTableRows.slice(start, start + this.tablePageSize);
		},
	},
	watch: {
		campnId(val) {
			if (val) this.fetchAllEventList();
		},
	},
	async created() {
		await this.getCommonCdList();
		this.fetchAllEventList();
	},
	methods: {
		normalizeRegion(name) {
			if (!name) return '';
			let n = name.replace(/[·\s]/g, '').trim();
			if (['전남광주', '광주전남', '전남', '광주'].includes(n)) {
				return '전남광주';
			}
			const aliases = {
				'서울특별시': '서울', '서울시': '서울',
				'인천광역시': '인천', '인천시': '인천',
				'경기도': '경기',
				'강원도': '강원', '강원특별자치도': '강원',
				'세종특별자치시': '세종', '세종시': '세종',
				'충청북도': '충북', '충북도': '충북',
				'충청남도': '충남', '충남도': '충남',
				'대전광역시': '대전', '대전시': '대전',
				'전라북도': '전북', '전북도': '전북', '전북특별자치도': '전북',
				'경상북도': '경북', '경북도': '경북',
				'경상남도': '경남', '경남도': '경남',
				'대구광역시': '대구', '대구시': '대구',
				'부산광역시': '부산', '부산시': '부산',
				'울산광역시': '울산', '울산시': '울산',
				'제주특별자치도': '제주', '제주도': '제주', '제주시': '제주'
			};
			if (aliases[n]) {
				return aliases[n];
			}
			return n;
		},

		ensureExternalUrl(url) {
			if (!url || typeof url !== 'string') return '';
			const trimmed = url.trim();
			if (!trimmed || trimmed === 'javascript:void(0);' || trimmed === '#') {
				return '';
			}
			if (/^https?:\/\//i.test(trimmed)) {
				return trimmed;
			}
			return 'https://' + trimmed;
		},

		formatImgUrl(url) {
			if (!url || typeof url !== 'string') return this.defaultImg;
			const trimmed = url.trim();
			if (!trimmed) return this.defaultImg;
			if (/^https?:\/\//i.test(trimmed)) {
				return trimmed;
			}
			return trimmed.startsWith('/') ? trimmed : '/' + trimmed;
		},

		onImgError(e) {
			e.target.src = this.defaultImg;
		},

		selectRegion(regionName, regionCode) {
			this.selectedRegionName = regionName;
			this.selectedRegionCode = regionCode;
			this.cardPage = 1;
		},

		getRegionCardCount(regionName) {
			const normTarget = this.normalizeRegion(regionName);
			return this.allEventList.filter((item) => {
				const normItem = this.normalizeRegion(item.displayRegionNm);
				if (normTarget === '전남광주') {
					return normItem === '전남광주';
				}
				return normItem.includes(normTarget) || normTarget.includes(normItem);
			}).length;
		},

		onSearchFilter() {
			this.tablePage = 1;
		},

		formatDate(ymd) {
			if (!ymd) return '';
			return ymd.substring(0, 10).replace(/-/g, '.');
		},

		async getCommonCdList() {
			const getArDcdOptions = () => {
				this.arDcdOptions = this.commonCode
					.filter((x) => x.dbColumn === 'AR_DCD')
					.map((y) => ({ dcd: y.dcd, dcdVal: y.dcdVal }));
			};

			if (this.commonCode.length === 0) {
				try {
					const res = await this.$store.dispatch(`common/${ACT_GET_COMMON_CODE_LIST}`, {});
					this.$store.commit(`common/${MUT_SET_COMMON_CODE_ITEMS}`, getCheckItems(res));
					getArDcdOptions();
				} catch (err) {
					console.error(err);
				}
			} else {
				getArDcdOptions();
			}
		},

		async fetchAllEventList() {
			const modelAttr = {
				pageSize: 2 ** (31 - 1),
			};
			if (this.campnId && this.campnId > 0) {
				modelAttr.campnId = this.campnId;
			}

			try {
				let res = await this.$store.dispatch(`festival/${ACT_GET_AR_EVENT_LIST}`, modelAttr);
				// campnId 필터링으로 결과가 없을 경우 전체 조회 재시도 (안전장치)
				if (!lengthCheck(res) && modelAttr.campnId) {
					const fallbackAttr = { pageSize: 2 ** (31 - 1) };
					res = await this.$store.dispatch(`festival/${ACT_GET_AR_EVENT_LIST}`, fallbackAttr);
				}

				if (lengthCheck(res)) {
					const items = getItems(res);
					this.allEventList = items.map((item) => {
						// 1. arDcd가 한글 지역명 또는 공통코드값인지 확인하여 지역명 매핑
						let arNm = (item.arDcd || item.arDcdNm || '').trim();
						const foundCode = this.arDcdOptions.find((dcd) => dcd.dcd == item.arDcd);
						if (foundCode && foundCode.dcdVal) {
							arNm = foundCode.dcdVal;
						}
						const normAr = this.normalizeRegion(arNm);
						if (normAr === '전남광주') {
							arNm = '전남·광주';
						}

						const bgngYmd = this.formatDate(item.eventBgngYmd);
						const endYmd = this.formatDate(item.eventEndYmd);
						const displayDate = bgngYmd && endYmd ? `${bgngYmd} ~ ${endYmd}` : (item.eventDur || '-');
						const displayDur = item.eventDur || displayDate;
						const finalImg = this.formatImgUrl(item.imgFileUrl);

						return {
							...item,
							displayRegionNm: arNm,
							displayDate: displayDate,
							displayDur: displayDur,
							imgFileUrl: finalImg,
						};
					});
				} else {
					this.allEventList = [];
				}
			} catch (err) {
				console.error(err);
			}
		},
	},
};
</script>

<style scoped>
/* 페이지 전체 배경 초기화 (코그페와 완전 동일하게 순백색 배경 적용) */
.page-container.regional-festival-page {
	background: #ffffff !important;
	background-image: none !important;
}

.regional-festival-page .page-content {
	margin-top: 0 !important;
	margin-bottom: 60px !important;
	padding-top: 20px !important;
	padding-bottom: 60px !important;
	background: #ffffff !important;
	background-image: none !important;
}

.regional-festival-page .container {
	max-width: 1400px;
	margin: 0 auto;
	padding: 0 20px;
}

/* 코그페 메인 타이틀 영역 */
.conTitArea {
	display: flex;
	align-items: center;
	justify-content: space-between;
}

.conTitArea.line.main-title-area {
	border-bottom: 2px solid #000000;
	padding: 30px 0 20px;
	margin-bottom: 10px;
}

.conTitArea.line.main-title-area h2 {
	font-weight: 700;
	font-size: 34px;
	color: #000000;
	margin: 0;
}

.mapNoticeTxt {
	margin-top: 20px;
	margin-bottom: 24px;
	font-size: 15px;
	color: #64748b;
	line-height: 1.6;
	word-break: keep-all;
}

/* 지도 영역 */
.mapArea {
	display: flex;
	border: 1px solid #ededed;
	border-radius: 12px;
	overflow: hidden;
	background: #fff;
}

.mapArea .map {
	flex: 4;
	display: flex;
	flex-direction: column;
	padding: 20px 40px;
	background: #f9f9f9;
	border-right: 1px solid #ededed;
}

.conTitArea.col {
	display: flex;
	flex-direction: column;
	align-items: flex-start;
	margin-bottom: 15px;
}

.conTitArea.col h2 {
	font-size: 24px;
	font-weight: 700;
	color: #1e293b;
	margin: 0;
}

.conTitArea .iconTxt {
	margin-top: 8px;
	font-size: 14px;
	color: #64748b;
}

.mapArea .mapImg {
	position: relative;
	margin: 10px auto;
	width: 100%;
	max-width: 440px;
}

.mapArea .mapImg svg {
	display: block;
	width: 100%;
	height: auto;
}

.mapArea .mapImg svg path.region {
	fill: #fff;
	stroke: #ccc;
	stroke-width: 1.764px;
	cursor: pointer;
	transition: fill 0.2s ease, opacity 0.2s ease;
}

.mapArea .mapImg svg path.region:hover {
	opacity: 0.85;
}

.mapArea .mapImg svg path.region.curr {
	stroke: #6189ec;
	fill: #e4ecff;
}

.regionBtnList {
	position: absolute;
	inset: 0;
	pointer-events: none;
}

.regionBtn {
	position: absolute;
	transform: translate(-50%, -50%);
	width: 58px;
	height: 58px;
	background: #fff;
	border: 1px solid #ededed;
	border-radius: 50%;
	box-shadow: 0 2px 7px rgba(0, 0, 0, 0.08);
	font-size: 14px;
	color: #475569;
	cursor: pointer;
	pointer-events: auto;
	display: flex;
	flex-direction: column;
	align-items: center;
	justify-content: center;
	padding: 0;
	transition: all 0.2s;
}

.regionBtn span.mapNum {
	display: block;
	font-size: 11px;
	margin-top: 2px;
	color: #64748b;
}

.regionBtn:hover,
.regionBtn.curr {
	background: #457aff;
	border-color: #457aff;
	font-weight: 700;
	color: #fff;
}

.regionBtn:hover span.mapNum,
.regionBtn.curr span.mapNum {
	color: #fff;
}

/* 우측 상단 축제 카드 리스트 */
.mapArea .mapImgList {
	flex: 6;
	display: flex;
	flex-direction: column;
	justify-content: flex-start;
	padding: 24px 36px;
}

.mapArea .mapImgList .conTitArea.dLeft {
	display: flex;
	justify-content: space-between;
	align-items: center;
	padding-bottom: 16px;
	border-bottom: 1px solid #e2e8f0;
	margin-bottom: 20px;
}

.mapArea .mapImgList .conTitArea.dLeft h2 {
	font-size: 22px;
	font-weight: 700;
	color: #1e293b;
	margin: 0;
}

.mapArea .mapImgList .conTitArea.dLeft h2 span.cBlue {
	color: #457aff;
}

.mapArea .mapImgList .conTitArea.dLeft span {
	font-size: 15px;
	color: #64748b;
}

.mapArea .mapImgList .imgTxtList.col3 {
	display: grid;
	grid-template-columns: repeat(3, 1fr);
	gap: 20px 16px;
	width: 100%;
}

.mapArea .mapImgList .imgTxtList .item {
	display: flex;
	flex-direction: column;
	text-decoration: none;
	min-width: 0;
}

.mapArea .mapImgList .imgTxtList .thumeImg {
	width: 100%;
	aspect-ratio: 1 / 1.25;
	border-radius: 8px;
	overflow: hidden;
	background: #f1f5f9;
	margin: 0;
}

.mapArea .mapImgList .imgTxtList .thumeImg img {
	width: 100%;
	height: 100%;
	object-fit: cover;
}

.mapArea .mapImgList .imgTxtList .item > div {
	padding-top: 10px;
}

.mapArea .mapImgList .imgTxtList .item > div strong {
	display: block;
	font-size: 16px;
	font-weight: 700;
	color: #1e293b;
	white-space: nowrap;
	overflow: hidden;
	text-overflow: ellipsis;
	line-height: 1.4;
}

.mapArea .mapImgList .imgTxtList .item > div p {
	margin-top: 4px;
	font-size: 13px;
	color: #64748b;
	line-height: 1.4;
	white-space: nowrap;
	overflow: hidden;
	text-overflow: ellipsis;
}

.mapArea .mapImgList .imgTxtList .item > div p.eventPlace {
	margin-top: 2px;
	color: #475569;
}

.noDataArea {
	width: 100%;
	text-align: center;
	padding: 50px 20px;
	background: #f8fafc;
	border-radius: 12px;
	border: 1px dashed #cbd5e1;
	margin: 20px 0;
}

.noDataArea p.noDataTxt {
	font-size: 16px;
	font-weight: 700;
	color: #475569;
	margin: 0;
}

/* 배너 영역 */
.banner-wrap {
	display: flex;
	flex-direction: column;
	gap: 20px;
	width: 100%;
	margin-top: 36px;
}

.banner {
	display: flex;
	align-items: center;
	text-decoration: none;
	border-radius: 12px;
	position: relative;
	color: #222;
	overflow: hidden;
}

.banner-content {
	display: flex;
	flex-direction: column;
	align-items: flex-start;
	gap: 14px;
	flex: 1;
	min-width: 0;
}

.banner-main {
	justify-content: space-between;
	padding: 24px 60px;
	background-color: #f1f5fe;
	gap: 32px;
}

.banner-main h3 {
	font-size: 32px;
	font-weight: 700;
	line-height: 1.4;
	margin: 0;
	word-break: keep-all;
}

.banner-main h3 strong,
.banner-2 h3 strong {
	color: #126df5;
}

.banner-3 h3 strong {
	color: #02912a;
}

.banner-main .banner-img {
	width: 150px;
	height: 150px;
	flex-shrink: 0;
	display: flex;
	align-items: center;
	justify-content: center;
}

.banner-main .banner-img img,
.banner-sub .banner-img img {
	width: 100%;
	height: 100%;
	object-fit: contain;
}

.banner-row {
	display: flex;
	gap: 20px;
}

.banner-sub {
	flex: 1 1 0;
	min-width: 0;
	padding: 24px 36px;
	gap: 24px;
	display: flex;
	align-items: center;
}

.banner-sub h3 {
	font-size: 24px;
	font-weight: 700;
	line-height: 1.4;
	margin: 0;
	word-break: keep-all;
}

.banner-2 {
	background-color: #f1f5fe;
}

.banner-3 {
	background-color: #f2f9f3;
}

.banner-sub .banner-img {
	width: 120px;
	height: 120px;
	flex-shrink: 0;
	display: flex;
	align-items: center;
	justify-content: center;
}

.banner-link {
	display: inline-flex;
	align-items: center;
	gap: 12px;
	font-size: 20px;
	font-weight: 700;
	color: #111;
	white-space: nowrap;
}

.banner-link::after {
	content: "→";
	font-size: 20px;
}

/* 검색 영역 (코그페와 완전 동일한 센터 정렬 알약 스타일) */
.srchArea {
	margin-top: 60px;
	margin-bottom: 24px;
}

.srchArea > div {
	display: flex;
	align-items: center;
	justify-content: center;
	gap: 12px;
	margin: 0 auto;
	max-width: 1010px;
	width: 100%;
}

.srchArea select,
.srchArea input[type="text"] {
	padding: 0 20px;
	height: 60px;
	border: none;
	font-family: inherit;
	font-size: 19px;
	color: #333;
}

.srchArea select {
	max-width: 200px;
	width: 100%;
	border-radius: 30px;
	border: 2px solid #ccc;
	background: #fff url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='16' height='16' viewBox='0 0 24 24' fill='none' stroke='%23333' stroke-width='2.5' stroke-linecap='round' stroke-linejoin='round'%3E%3Cpolyline points='6 9 12 15 18 9'%3E%3C/polyline%3E%3C/svg%3E") no-repeat calc(100% - 20px) center / 16px auto;
	appearance: none;
	-webkit-appearance: none;
	cursor: pointer;
	outline: none;
	transition: border-color 0.2s ease, box-shadow 0.2s ease;
}

.srchArea select:focus {
	border-color: #252c5d;
	box-shadow: 0 0 0 3px rgba(37, 44, 93, 0.1);
}

.srchArea > div > div {
	position: relative;
	flex: 1;
	width: 100%;
	height: 60px;
	padding-right: 60px;
	overflow: hidden;
	border-radius: 30px;
	border: 2px solid #ccc;
	background: #fff;
	transition: border-color 0.2s ease, box-shadow 0.2s ease;
}

.srchArea > div > div:focus-within {
	border-color: #252c5d;
	box-shadow: 0 0 0 3px rgba(37, 44, 93, 0.1);
}

.srchArea > div > div input[type="text"] {
	width: 100%;
	height: 100%;
	border-radius: 30px 0 0 30px;
	border: none;
	outline: none;
	padding: 0 24px;
	font-size: 19px;
	color: #222;
	background: transparent;
}

.srchArea > div > div input[type="text"]::placeholder {
	color: #999;
}

.srchArea > div > div button {
	position: absolute;
	top: 0;
	right: 0;
	width: 60px;
	height: 100%;
	border: none;
	background: transparent url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='24' height='24' viewBox='0 0 24 24' fill='none' stroke='%23333' stroke-width='2.5' stroke-linecap='round' stroke-linejoin='round'%3E%3Ccircle cx='11' cy='11' r='8'%3E%3C/circle%3E%3Cline x1='21' y1='21' x2='16.65' y2='16.65'%3E%3C/line%3E%3C/svg%3E") no-repeat center / 24px auto;
	cursor: pointer;
	transition: transform 0.15s ease, opacity 0.15s ease;
}

.srchArea > div > div button:hover {
	opacity: 0.75;
	transform: scale(1.08);
}

/* 하단 상권 목록 테이블 (코그페 event_region.jsp 원본 동일 스타일) */
.table-section {
	margin-top: 40px;
}

.table-section .conTitArea.line {
	border-bottom: 1px solid #000;
	padding-bottom: 12px;
	margin-bottom: 16px;
}

.table-section .conTitArea.line h2 {
	font-size: 24px;
	font-weight: 700;
	color: #000;
	margin: 0;
}

.tableList {
	margin-top: -1px;
	padding-bottom: 20px;
	width: 100%;
}

.tableList table {
	border-top: 2px solid #444;
	width: 100%;
	border-collapse: collapse;
}

.tableList table caption {
	position: absolute;
	clip: rect(0 0 0 0);
	width: 1px;
	height: 1px;
	margin: -1px;
	overflow: hidden;
}

.tableList table tbody tr {
	border-bottom: 1px solid #eaeaea;
}

.tableList table thead th,
.tableList table tbody td {
	padding: 7px 20px;
	height: 50px;
	font-family: 'Pretendard', -apple-system, BlinkMacSystemFont, system-ui, sans-serif;
	font-size: 17px;
	letter-spacing: 0;
	text-align: center;
}

.tableList table thead th {
	background: #f9f9f9;
	color: #000;
	font-weight: 700;
}

.tableList table tbody td {
	background: #fff;
	color: #444;
}

.tableList table tbody td a {
	color: #444;
	text-decoration: none;
}

.tableList table tbody td a:hover {
	padding-bottom: 1px;
	border-bottom: 1px solid #444;
}

.tableList table tbody td.txtL {
	text-align: left;
}

.tableList table tbody td.full {
	white-space: pre-line;
	word-break: keep-all;
}

/* 페이징 */
.pagination {
	display: flex;
	justify-content: center;
	padding: 24px 0;
}

.pagination div {
	display: flex;
	align-items: center;
	gap: 6px;
}

.pagination div > * {
	display: inline-flex;
	align-items: center;
	justify-content: center;
	min-width: 32px;
	height: 32px;
	padding: 0 6px;
	font-size: 15px;
	font-weight: 600;
	color: #475569;
	text-decoration: none;
	border-radius: 4px;
	cursor: pointer;
	user-select: none;
}

.pagination div strong {
	background: #457aff;
	color: #fff;
}

.pagination div a:hover:not(.disabled) {
	background: #e2e8f0;
}

.pagination div a.disabled {
	opacity: 0.35;
	cursor: default;
	pointer-events: none;
}

.pagination div .btnPrev,
.pagination div .btnNext {
	font-weight: 400;
	padding: 0 10px;
}

@media (max-width: 1024px) {
	.mapArea {
		flex-direction: column;
	}
	.mapArea .map {
		border-right: none;
		border-bottom: 1px solid #ededed;
		padding: 20px;
	}
	.mapArea .mapImgList {
		padding: 20px;
	}
	.banner-row {
		flex-direction: column;
		gap: 16px;
	}
	.banner-main {
		padding: 24px 40px;
		gap: 24px;
	}
	.banner-main .banner-img {
		width: 110px;
		height: 110px;
	}
	.banner-main h3 {
		font-size: 24px;
	}
	.banner-sub {
		padding: 20px 28px;
		gap: 20px;
	}
	.banner-sub .banner-img {
		width: 90px;
		height: 90px;
	}
	.banner-sub h3 {
		font-size: 20px;
	}
	.banner-link {
		font-size: 17px;
	}
	.banner-link::after {
		font-size: 17px;
	}
}

@media (max-width: 940px) {
	.mHide,
	.tableList table colgroup,
	.tableList table thead {
		display: none !important;
	}

	.mapArea .mapImgList .imgTxtList.col3 {
		grid-template-columns: repeat(2, 1fr);
		gap: 16px 12px;
	}

	/* 모바일 배너 영역 (배너 짤림 방지 및 단독 배너 이미지 크기 최적화) */
	.banner-wrap {
		margin-top: 24px;
		gap: 12px;
	}

	.banner-content {
		gap: 8px;
		flex: 1;
		min-width: 0;
	}

	.banner-main {
		padding: 16px 20px;
		gap: 16px;
	}

	.banner-main h3 {
		font-size: 16px;
		line-height: 1.35;
		word-break: keep-all;
	}

	.banner-main .banner-img {
		width: 68px;
		height: 68px;
		flex-shrink: 0;
	}

	.banner-row {
		flex-direction: column;
		gap: 12px;
	}

	.banner-sub {
		padding: 16px 20px;
		gap: 16px;
	}

	.banner-sub h3 {
		font-size: 16px;
		line-height: 1.35;
		word-break: keep-all;
	}

	.banner-sub .banner-img {
		width: 68px;
		height: 68px;
		flex-shrink: 0;
	}

	.banner-link {
		font-size: 14px;
		gap: 8px;
		white-space: nowrap;
	}

	.banner-link::after {
		font-size: 14px;
	}

	/* 모바일 검색 영역 */
	.srchArea {
		margin-top: 32px;
		margin-bottom: 20px;
	}
	.srchArea > div {
		width: 100%;
		flex-direction: column;
		gap: 10px;
	}
	.srchArea select,
	.srchArea input[type="text"] {
		height: 56px !important;
		font-size: 17px !important;
		padding: 0 16px !important;
	}
	.srchArea select {
		max-width: 100%;
		width: 100%;
	}
	.srchArea > div > div {
		width: 100%;
		height: 48px;
		padding-right: 50px;
	}
	.srchArea > div > div button {
		width: 50px;
		background-size: 20px auto;
	}

	/* 모바일 상권 목록 섹션 */
	.table-section {
		margin-top: 30px;
	}
	.table-section .conTitArea.line {
		padding-bottom: 10px;
		margin-bottom: 14px;
	}
	.table-section .conTitArea.line h2 {
		font-size: 20px;
	}

	/* 모바일 상권 목록 테이블 (코그페 event_region.jsp 완전 동일 스타일) */
	.tableList table colgroup,
	.tableList table thead th,
	.tableList table thead,
	.mHide {
		display: none !important;
	}

	.tableList table tbody {
		display: block;
		width: 100%;
	}

	.tableList table tbody tr {
		display: flex;
		flex-wrap: wrap;
		flex-direction: column;
		padding: 12px 0 10px;
		gap: 4px;
		border-bottom: 1px solid #eaeaea;
		background: #fff;
	}

	.tableList table tbody tr td {
		text-align: left;
		font-size: 15px;
		display: flex;
		align-items: flex-start;
		padding: 0;
		word-break: break-all;
		min-height: 30px;
		height: auto;
		gap: 10px;
		background: #fff;
		color: #444;
		border: none;
	}

	.tableList table tbody tr td.full {
		flex-basis: 100%;
		width: 100%;
		height: auto;
	}

	.tableList table tbody tr td[data-th]::before {
		display: inline-block;
		content: attr(data-th);
		width: 100%;
		padding-right: 5px;
		font-weight: 700;
		color: #000;
		flex: 0 0 100px;
		min-width: 100px;
	}

	.tableList table tbody tr td a {
		color: #444;
		text-decoration: none;
	}

	.tableList table tbody tr td a:hover {
		padding-bottom: 1px;
		border-bottom: 1px solid #444;
	}

	.mHide.row-num {
		display: none !important;
	}

	/* 빈 데이터 행 */
	.tableList table tbody tr:not(.event-table-row) td {
		display: block;
		width: 100%;
		text-align: center;
		padding: 40px 0;
		color: #64748b;
		font-size: 15px;
		min-height: auto;
	}

	/* 모바일 페이징 */
	.pagination.table-pagination {
		padding: 16px 0 24px;
	}
	.pagination.table-pagination div {
		gap: 4px;
		flex-wrap: wrap;
		justify-content: center;
	}
	.pagination.table-pagination div > * {
		min-width: 36px;
		height: 36px;
		font-size: 14px;
	}
}

@media (max-width: 480px) {
	.mapArea .mapImgList .imgTxtList.col3 {
		grid-template-columns: 1fr;
	}

	/* 소형 모바일 배너 세부 최적화 */
	.banner-wrap {
		margin-top: 20px;
		gap: 10px;
	}

	.banner-content {
		gap: 6px;
	}

	.banner-main {
		padding: 14px 16px;
		gap: 12px;
	}

	.banner-main h3 {
		font-size: 15px;
	}

	.banner-main .banner-img {
		width: 60px;
		height: 60px;
	}

	.banner-row {
		gap: 10px;
	}

	.banner-sub {
		padding: 35px 16px;
		gap: 12px;
	}

	.banner-sub h3 {
		font-size: 14px;
	}

	.banner-sub .banner-img {
		width: 60px;
		height: 60px;
	}

	.banner-link {
		font-size: 13px;
		gap: 6px;
	}

	.banner-link::after {
		font-size: 13px;
	}
}
</style>
